module.exports = __webpack_public_path__ + "img/item1-m.4e3b4aad.png";